<div class="mat-form-field-relative-wrapper">
  @if (label || hasUpdatePermission) {
    <div class="input-assign-role-header">
      <div class="input-assign-role-header-name">{{ label }}</div>
      <div class="flex-space"></div>
      @if (hasUpdatePermission) {
        <nimbus-input-parameters-overlay
          customClass="with-paddings"
          [optionsToAdd]="optionsToAdd"
          [selectableBodyTemplateRef]="itemSelectableBody"
          [isLoading]="false"
          [filtering]="false"
          [isDisabled]="isDisabled"
          (itemAdd)="insertParameter($event)"
          (closePanel)="onClose()"
          (searchPhrase)="onSearch($event)"
        >
        </nimbus-input-parameters-overlay>
      }
    </div>
  }

  <div class="service-user-list">
    <nimbus-grid
      class="flex-grow"
      [data]="entities$ | async"
      [loading]="loading$ | async"
      [sortable]="{ allowUnsort: false, mode: 'single' }"
      [sort]="sort$ | async"
      [skip]="skip"
      [pageable]="{ responsive: false }"
      [pageSize]="pageSize$ | async"
      (pagingChange)="pagingChange($event)"
      (sortingChange)="sortingChange($event)"
    >
      @if (isBulk) {
        <nimbus-grid-column width="20" field="bulkIdentical">
          <ng-template let-dataItem="dataItem">
            <div
              class="bulk-identical"
              [nimbusBulkValue]="getBulkItem(dataItem.id)"
              [identical]="getBulkItem(dataItem.id)?.identical"
              [bulkDisabled]="dataItem?.isReadonly"
              [isBulk]="isBulk"
            ></div>
          </ng-template>
        </nimbus-grid-column>
      }
      <nimbus-grid-column field="name" class="text-limit" [title]="TranslationKeys.GeneralRole | icuTranslate: PluralForm.Other">
        <ng-template let-dataItem="dataItem">
          <div class="role-name-cell">
            @if (isNotAvailableItem(dataItem.id)) {
              <span class="bulk-disabled-warning tooltip-container">
                <i [nimbusIcon]="ICONS.WARNING_LIGHT"></i>
                <nimbus-tooltip
                  [text]="
                    (isBulk ? TranslationKeys.AdminUserListRolesApplyCannotBeApplied : TranslationKeys.GeneralNpdItemWarning) | translate
                  "
                  [position]="'left'"
                ></nimbus-tooltip>
              </span>
            }
            <span class="text-no-wrap tooltip-container">{{ dataItem.name }}</span>
          </div>
        </ng-template>
      </nimbus-grid-column>

      <nimbus-grid-column
        field="organizationUnits"
        class="tag-column"
        [title]="TranslationKeys.GeneralOrganizationUnits | translate"
        [sortable]="false"
      >
        <ng-template let-dataItem="dataItem">
          @if (dataItem.organizationUnits && dataItem.organizationUnits.length && (!isBulk || !hasInitiallyEmpty(dataItem.id))) {
            <nimbus-tag-list
              [tagNames]="dataItem.organizationUnits | toTag"
              [isBulk]="isBulk"
              [bulkValues]="getBulkItem(dataItem.id)?.value?.organizationUnits"
              [bulkDisabled]="dataItem?.isReadonly"
            ></nimbus-tag-list>
          } @else {
            <div class="missing-ou-error">
              <i [nimbusIcon]="ICONS.WARNING"></i>
              <nimbus-tooltip
                [text]="'You need to add at least one Organization Unit to the assigned role'"
                [position]="'left'"
              ></nimbus-tooltip>
            </div>
          }
        </ng-template>
      </nimbus-grid-column>

      <nimbus-grid-column field="id" class="actions-column" [sortable]="false" [width]="isBulk ? 70 : 50" textAlignment="right">
        <ng-template let-dataItem="dataItem">
          <div class="grid-control-icons flex-container flex-align-center-right">
            @if (isBulk && isEditButtonDisplayed(dataItem)) {
              <button
                (click)="onApplyItem(dataItem)"
                [disabled]="getBulkItem(dataItem.id)?.identical || isBulkReadonlyLocal(dataItem.id)"
                nimbusPrimaryIconButton
              >
                <i [nimbusIcon]="ICONS.ADD"></i>
                <nimbus-tooltip [position]="'left'" [text]="getApplyTooltip(dataItem.id) | translate"></nimbus-tooltip>
              </button>
            }
            @if (isEditButtonDisplayed(dataItem)) {
              <button
                nimbusPrimaryIconButton
                [disabled]="dataItem.workflowsCount || (isBulk && !getBulkItem(dataItem.id)?.identical) || isNotAvailableItem(dataItem.id)"
                (click)="onEditClick(dataItem)"
              >
                <i [nimbusIcon]="ICONS.PEN_LIGHT"></i>
                <nimbus-tooltip [text]="TranslationKeys.GeneralEdit | translate" [position]="'left'"></nimbus-tooltip>
              </button>
            }
            @let isNonRemovable = isNonRemovableRoleId(dataItem.id);
            @if (!dataItem?.isReadonly && hasUpdatePermission) {
              <button
                nimbusPrimaryIconButton
                nimbusNegativeButton
                [disabled]="dataItem.workflowsCount || isNonRemovable"
                (click)="onRemoveItemClick(dataItem)"
              >
                <i [nimbusIcon]="ICONS.TRASH_LIGHT"></i>
                <nimbus-tooltip
                  [text]="
                    (isNonRemovable ? TranslationKeys.AdminUserListRolesApplyCannotBeDeleted : TranslationKeys.GeneralRemove) | translate
                  "
                  [position]="'left'"
                ></nimbus-tooltip>
              </button>
            }
          </div>
        </ng-template>
      </nimbus-grid-column>
    </nimbus-grid>
  </div>

  <ng-template #itemSelectableBody let-item="item">
    <div class="flex-container url-parameter">
      {{ item.name }}
      <nimbus-tooltip [text]="(!item.isDisabled ? item.name : TranslationKeys.GeneralRoleLimitDescription) | translate"></nimbus-tooltip>
    </div>
  </ng-template>
</div>
